// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"4b49b643","127":"b2248190","250":"ff80fd40","301":"263083b8","453":"fa130eff","574":"77417ea0","591":"21d15935","697":"3c86b744","807":"44dc6266","949":"23986f2d","979":"da1f8c33"}[chunkId] + ".chunk.js";
};